import { render, staticRenderFns } from "./coupon-list.vue?vue&type=template&id=72bf7f9a&"
import script from "./coupon-list.vue?vue&type=script&lang=js&"
export * from "./coupon-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports